import React, { ReactNode } from "react";
import { Box, Header } from "@cloudscape-design/components";
import "./section-header.scss";

export interface SectionHeaderProps {
  title: string;
  icon?: ReactNode;
  actions?: ReactNode;
  variant?: "h1" | "h2" | "h3";
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  icon,
  actions,
  variant = "h1",
  className = "",
}) => {
  return (
    <div
      className={`finspace-section-header finspace-section-header--${variant} ${className}`}
    >
      <div className="finspace-section-header__title-container">
        <div>
          {icon && <div className="finspace-section-header__icon">{icon}</div>}
          <Box variant="awsui-key-label">
            <Header variant={variant}>{title}</Header>
          </Box>
        </div>
        <div>
          {actions && (
            <div className="finspace-section-header__actions">{actions}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;
